module.exports = __webpack_public_path__ + "static/img/main_visual_mo.59e6547.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main_visual_mo.jpg
// module id = Ky+B
// module chunks = 34